module.exports = __webpack_public_path__ + "static/img/stone_share.816356f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/stone_share.jpg
// module id = 3yD1
// module chunks = 26